import React from 'react';
import { returnCorrectPath } from '~/modules/manageRouting';
import { PLAYBOOK_EXECUTION_TRIGGER_TYPES as TRIGGER_TYPES } from '~/modules/playbookExecutionTypes';

export const triggerLinkCellRender = params => {
    const { trigger_type, trigger_id } = params?.data || {};
    if (!(trigger_type && trigger_id)) {
        return '';
    }
    const kansoActive = SETTINGS.NEWUI;

    let url = '';

    switch (trigger_type) {
        case TRIGGER_TYPES.INCIDENT:
            url = returnCorrectPath(
                'incidentsDetails',
                !kansoActive,
                trigger_id
            );
            break;
        case TRIGGER_TYPES.TRIAGE:
            url = returnCorrectPath('triageDetails', !kansoActive, trigger_id);
            break;
        case TRIGGER_TYPES.MONITOR_ALERT:
            if (kansoActive) {
                url = `/alerts/${trigger_id}`;
            } else {
                url = `/ui/#/alert/${trigger_id}`;
            }
            break;
        case TRIGGER_TYPES.INSIGHT:
            if (kansoActive) {
                url = `/insight/${trigger_id}`;
            } else {
                url = `/sec/insight/${trigger_id}`;
            }
            break;
        case TRIGGER_TYPES.ENTITY:
            url = `/sec/entity?entityId=${trigger_id}`;
            break;
        default:
            break;
    }

    if (url) {
        const handleClick = e => {
            // Prevent row click event
            e.stopPropagation();
            if (e.nativeEvent) {
                e.nativeEvent.stopImmediatePropagation();
            }
        };

        return (
            <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary"
                onClickCapture={handleClick}
            >
                {trigger_type}
            </a>
        );
    }

    return <span>{trigger_type || ''}</span>;
};
